const setRegHalf = (payload) => {
  return {
    type: "reghalf",
    payload,
  };
};

export default setRegHalf;
